module.exports = __webpack_public_path__ + "static/media/icon-filter.154433cb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-filter.svg
// module id = 172
// module chunks = 0 1 2